module.exports = __webpack_public_path__ + "static/media/prev.ff7c52f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/prev.svg
// module id = 334
// module chunks = 0